import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';

import mutations from './login.mutations.js';
import actions from './login.actions.js';
import getters from './login.getters.js';
import state from './login.state.js';


BaseStore.registerModule('login', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('login');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
